import { memo } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'

import { useOpenHelpContact } from '../../modules/support/shared/help-contact-dialog/help-contact-hooks.ts'

import { GenericProblemMessage } from './generic-problem-message.tsx'

export const InvalidLinkMessage = memo(function InvalidLinkMessage() {
  const translate = useTranslate()
  const openHelpContact = useOpenHelpContact()
  return (
    <GenericProblemMessage
      title={translate('problem_invalid_link_title')}
      principalMessage={translate('problem_invalid_link_principal_message')}
      firstSubText={translate('problem_invalid_link_first_subtext')}
      secondSubText={translate('problem_invalid_link_second_subtext')}
      buttonText={translate('contact_customer_support')}
      onButtonClick={openHelpContact}
    />
  )
})
